import styles from './mobile-app-footer.module.css'
import { Text } from '@cinch-labs/design-system'

const footerText =
  'Cinch Cars Limited is an appointed representative of ITC Compliance Limited which is authorised and regulated by the Financial Conduct Authority (their registration number is 313486). Permitted activities include acting as a credit broker not a lender. For further details visit cinch.co.uk. Representative APR 11.4%. Trade-in value of your car must be higher than outstanding finance amount. T&Cs & exclusions apply.'

export const MobileAppFooter = () => (
  <footer className={styles.footerContainer}>
    <Text element="p" fontSize="s" fontWeight="light" lineHeight="body">
      {footerText}
    </Text>
  </footer>
)
